export enum ChargerType {
	AC = 'AC',
	DC = 'DC',
	CPO = 'Home Wallbox',
}
